import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';

// Components
import Header from '../../components/Header/index';

// Firebase
import { useFirebaseApp } from 'reactfire';

// Material-ui
import { TextField, Snackbar, Button, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import './login.css';
import { db } from '../../utils/firebaseConfig';

const Login = () => {
    let history = useHistory();
    let firebase = useFirebaseApp();

    const [email, setEmail] = useState('');
    const [emailRecovery, setEmailRecovery] = useState('');
    const [senha, setSenha] = useState('');
    const [alert, setAlert] = useState('');
    const [success, setSuccess] = useState('');
    const [userExists, setUserExists] = useState(false);

    const [isLoading, setIsLoading] = useState(false);

    // Dialogs
    const [recoveryDialog, setShowRecovery] = useState(false);

    const showRecovery = () => setShowRecovery(true);

    const hideRecovery = () => setShowRecovery(false);

    // Alert
    const [openAlert, setShowAlert] = useState(false);
    const [openSuccess, setShowSuccess] = useState(false);

    const showAlert = () => setShowAlert(true);
    const showSuccess = () => setShowSuccess(true);

    const hideAlert = () => setShowAlert(false);
    const hideSuccess = () => setShowSuccess(false);

    const Login = () => {
        const login = {
            email: email,
            senha: senha
        };

        if (login.email.length === 0 || login.senha.length === 0) {
            setIsLoading(false);
            setAlert('Preencha os campos de email e senha para logar.')
            return showAlert();
        }

        // Autenticação automatizada com Firebase
        firebase.auth().signInWithEmailAndPassword(login.email, login.senha)
            .then(resp => {
                // Caso o objeto "user" não for indefinido ou nulo
                setIsLoading(false);
                if (resp.user && resp.user.emailVerified) {
                    localStorage.setItem('_tok_user', resp.user?.refreshToken);
                    history.push('/');
                }
                else {
                    // Envia para página de verificação de email
                    history.push('/email-verification');
                }
            })
            .catch(err => {
                console.log(err.code)
                setIsLoading(false);
                if (err.code === 'auth/user-not-found') {
                    setAlert('Usuário não encontrado.')
                    return showAlert();
                }
                else if (err.code === 'auth/invalid-email') {
                    setAlert('Email inválido.')
                    return showAlert();
                }
                else {
                    setAlert('Email ou Senha inválidos.')
                    return showAlert();
                }
            })
    }

    const RecoveryPassword = () => {
        if (emailRecovery.length === 0) {
            setAlert('Preencha seu email para prosseguir com a recuperação de senha.')
            return;
        }

        db.collection('Usuarios').where('email', '==', emailRecovery).get()
            .then(resp => {
                if(resp.docs.length !== 0)
                    setUserExists(true);
                else
                    setUserExists(false);
            })
        
            if(userExists){
                firebase.auth().sendPasswordResetEmail(emailRecovery)
                .then(() => {
                    setSuccess('Email de recuperação de senha enviado com sucesso.')
                    hideRecovery();
                    return showSuccess();
                })
                .catch((error) => {
                    setAlert('Houve um erro ao enviar email de recuperação de senha.')
                    return showAlert();
                })
            }
            else{
                setAlert('Este email não está cadastrado na plataforma.')
                return;
            }
    }

    return (
        <div>
            <Header />
            <Form className='form-signin' onSubmit={event => {
                event.preventDefault();
                setIsLoading(true);
                Login();
            }}>
                <div className='text-center'>
                    <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px' }} />
                </div>

                <br />
                <i><p style={{ textAlign: 'center', fontWeight: 'bold' }}>Faça Login em sua conta</p></i>
                <hr />

                <TextField
                    autoFocus
                    id="email"
                    margin="dense"
                    label="Informe o email"
                    type="email"
                    fullWidth
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                />

                <TextField
                    id="senha"
                    margin="dense"
                    label="Senha"
                    type="password"
                    fullWidth
                    value={senha}
                    onChange={event => setSenha(event.target.value)}
                />

                <Snackbar open={openAlert} autoHideDuration={6000} onClose={hideAlert}>
                    <Alert onClose={hideAlert} severity="error" variant="outlined">
                        {alert}
                    </Alert>
                </Snackbar>

            <Snackbar open={openSuccess} autoHideDuration={6000} onClose={() => {
                hideSuccess();
            }}>
                <Alert severity="success" variant="filled" onClose={() => {
                    hideSuccess();
                }}>
                    {success}
                </Alert>
            </Snackbar>

                <div className="btn-center">
                    <Button variant="contained" id="btn-padrao" type="submit" >
                        Entrar
                    </Button>
                </div>

                <div className="links-login">
                    <p>Novo no FreeTakistan? <Link to='/cadastro'>Crie uma conta</Link></p>
                </div>
                <div className="links-login">
                    <p><Button variant="text" color="primary" onClick={() => {
                        showRecovery();
                    }}>Esqueci minha senha</Button></p>
                </div>
            </Form>

            {/* Modal para recuperação de senha */}
            <Dialog open={recoveryDialog} aria-labelledby="form-dialog-title" onClose={() => {
                hideRecovery();
                setAlert('');
            }}>
                <DialogTitle id="form-dialog-title">Recuperação de Senha</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Para recuperar sua senha, preencha o campo abaixo:
                    </DialogContentText>
                    <TextField
                        error={alert != ''}
                        helperText={alert}
                        autoFocus
                        id="nome"
                        margin="dense"
                        label="Coloque seu email"
                        type="email"
                        fullWidth
                        value={emailRecovery}
                        onChange={event => setEmailRecovery(event.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={() => {
                        hideRecovery();
                        setAlert('');
                    }} >
                        Fechar
                    </Button>
                    <Button color="primary" onClick={(e) => {
                        RecoveryPassword();
                    }}>
                        Enviar
                    </Button>
                </DialogActions>
            </Dialog>
            {/* FIM do Modal para recuperação de senha */}
        </div>
    );
}

export default Login;
